import { Field, InputType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import type { IBaseEntity } from '../../base/BaseEntity'
import type { IActivityRepository } from '../IActivityRepository'

@InputType()
export class CreateRemarksActivityMentionArgs extends ActionArgs {
  @Field(() => String, { nullable: false })
  parentId: string

  @Field(() => String, { nullable: false })
  activity: string

  @Field(() => String)
  templateKey?: string

  @Field(() => String)
  url?: string
}

export type CreateRemarksActivityMentionType<T extends IBaseEntity> = CreateRemarksActivityMentionArgs & {
  activityRepository: IActivityRepository<T>
}

export interface ICreateRemarksActivityMention<T extends IBaseEntity> extends IAction<
  T,
  CreateRemarksActivityMentionType<T>
> {}
